import { render } from "./AddressEdit.vue?vue&type=template&id=3bf7138e&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=3bf7138e&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf7138e"],['__file',"src/views/order/products/AddressEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bf7138e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bf7138e', __exports__)) {
    console.log('reload')
    api.reload('3bf7138e', __exports__)
  }
  
  module.hot.accept("./AddressEdit.vue?vue&type=template&id=3bf7138e&scoped=true", () => {
    console.log('re-render')
    api.rerender('3bf7138e', render)
  })

}


export default __exports__